import React, { useState } from 'react';

import TextField from '@material-ui/core/TextField';

const Input = ({ accessor, onChange }) => {
  let [value, setValue] = useState('');

  const onChng = (e) => {
    setValue(e.target.value);
    onChange({ accessor, value: e.target.value });
  };

  return <TextField size="small" variant="outlined" label={false} value={value} onChange={onChng} />;
};

export default Input;
